
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Space } from 'antd';
import localeInfo from '@/config/locale';
import HeaderDropdown from '../HeaderDropdown';

type LanguageDropdownProps = {
  store: {
    locale: string,
    setLocale: Function,
  },
  showLanguge?: boolean,
};

const LanguageDropdown = observer(({ store, showLanguge = false } : LanguageDropdownProps) => {

  const handleClick = ({ key } : { key : string }) => {
    store.setLocale(key);
  };

  return (
    <HeaderDropdown
      menu={{
        items: Object.keys(localeInfo)
          .map(key => (
            { key, label: `${localeInfo[key]['icon']} ${localeInfo[key]['label']}` }
          )),
        onClick: handleClick,
        selectedKeys: [store.locale]
      }}
    >
      <Space className="action" size={4}>
        <i className='iconfont icon-translate1'></i>
        {showLanguge
          ? (
            <span style={{ whiteSpace: 'nowrap' }}>
              {(localeInfo[store.locale] && localeInfo[store.locale]['label']) || ''}
            </span>
          )
          : null}
      </Space>
    </HeaderDropdown>
  );
});

export default LanguageDropdown;
